import PropTypes from 'prop-types';
import { propTypes as i18nPropTypes } from '../hocs/intlEquipped';

export const actionPropType = PropTypes.shape({
    hidden: PropTypes.bool,
    order: PropTypes.number,
    text: PropTypes.string,
    trackingPayload: PropTypes.shape({
        id: PropTypes.string,
    }),
    type: PropTypes.string,
});

export const footerSectionProps = {
    headerKey: PropTypes.string.isRequired,
    descriptionKey: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        textKey: PropTypes.string.isRequired,
        link: PropTypes.string,
        type: PropTypes.string.isRequired,
        redirectToExternalPage: PropTypes.bool,
        trackingPayload: PropTypes.shape({}),
    })),
};

export const productPropType = PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    chargeName: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    chargeAmount: PropTypes.shape({
        currency: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
    }).isRequired,
    taxAmount: PropTypes.shape({
        currency: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
    }).isRequired,
    serviceStartDate: PropTypes.string.isRequired,
    serviceEndDate: PropTypes.string.isRequired,
});

export const fetchContainerPropTypes = {
    url: PropTypes.string.isRequired,
    loaderText: PropTypes.string,
    errorText: PropTypes.string,
    renderLoader: PropTypes.func,
    renderError: PropTypes.func,
    children: PropTypes.func.isRequired,
    options: PropTypes.shape({}),
    i18n: i18nPropTypes,
    theme: PropTypes.shape({}),
};
